import React, { memo } from 'react';
import classNames from 'classnames';

import { BREAKPOINTS } from 'constants/grid';
import { SSRMediaQuery } from 'components/SSRMediaQuery';

import styles from 'components/Trolley/TrolleySize/TrolleySize.scss';

import {
  TrolleyActive,
  TrolleyInactive,
} from '@johnlewispartnership/wtr-ingredients/foundations/icons';

interface TrolleySizeProps {
  dataTestId: string;
  highlightValue: boolean;
  size: number;
}

const TrolleySize = ({ dataTestId = '', highlightValue = true, size = 50 }: TrolleySizeProps) => {
  const itemQty = size > 99 ? '99+' : size;

  const TrolleyIcon = size ? TrolleyActive : TrolleyInactive;

  return (
    <span
      data-testid="trolley-size-container"
      className={classNames(styles.trolleySize, {
        [styles.highlight]: highlightValue,
      })}
    >
      <SSRMediaQuery minWidth={BREAKPOINTS.sm}>
        <div className={styles.icon}>
          <TrolleyIcon size="small" />
        </div>
      </SSRMediaQuery>

      <span className={styles.value} data-test-id={dataTestId}>
        {itemQty || null}
      </span>
    </span>
  );
};

export default memo(TrolleySize);
